import { AsciiEffect } from 'three/examples/jsm/effects/AsciiEffect.js';
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls.js';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

const easeOutQuad = t => t * ( 2 - t );

const ASCIICHARACTERS = ' .+/X0';
// const ASCIICHARACTERS = ' .\'`^",:;Il!i~+_-?][}{1)(|/tfjrxnuvczXYUJCLQ0OZmwqpdbkhao*#MW&8%B@$';
// const ASCIICHARACTERS = ' .:-+*=%☺@#'

export default class intro {
  constructor(){
    this.camera;
    this.controls;
    this.scene;
    this.renderer;
    this.composer;
    // this.effect;
    this.logo;
    this.camera;
    this.controls;
    // this.effect;
    // this.sphere;
    // this.plane;
    this.pointLight1;
    this.pointLight2;

    this.colorVal = 0.0;

    this.start = null;

    this.introDone = false;

    this.mousemove = this.mousemove.bind(this);
    this.mousemoved = false;
    this.init = this.init.bind(this);
    this.animate = this.animate.bind(this);
    this.render = this.render.bind(this);

    this.mouseCoords = new THREE.Vector3(0, 0, 0);
    if(MOBSIZE) {
      this.mouseCoords = new THREE.Vector3(0.6, 0, 0);
    }

    this.asciiPass = undefined;
    var uniforms = {
      time: {
        type: "f",
        value: 1.0
      },
      resolution: {
        type: "v2",
        value: new THREE.Vector2()
      },
      charsize : {
        type: "f",
        value: 4.0,
      },
      brightness : {
        type: "f",
        value: 0.3,
      }
    };
    uniforms.resolution.value.x = window.innerWidth;
    uniforms.resolution.value.y = window.innerHeight;
    
    this.shaderMaterial = new THREE.ShaderMaterial({
      uniforms: uniforms,
      vertexShader: document.getElementById('asc-general').textContent,
      fragmentShader: document.getElementById('asc-frag1').textContent
    });
    this.clock = new THREE.Clock();

    this.ORIGSPRITESCALE = MOBSIZE ? 20 : 30;

    window.animSpeed = 1.0;

    document.addEventListener( 'mousemove', this.onDocumentMouseMove.bind(this), false );
    document.addEventListener( 'touchmove', this.onDocumentTouchMove.bind(this), false );
    window.addEventListener( 'resize', this.onWindowResize.bind(this) );

    this.init();
    this.animate();

    window.intro = this;
  }

  init() {
    var parent = this;

    console.log('init');

    this.camera = new THREE.PerspectiveCamera( 10, window.innerWidth / window.innerHeight, 1, 5000 );
    this.camera.position.y = 0;
    this.camera.position.z = 500;

    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color( 0, 0, 0 );

    this.pointLight1 = new THREE.PointLight( 0xffffff, 0.0);
    this.pointLight1.position.set( 400, 400, 400 );
    this.scene.add( this.pointLight1 );

    this.pointLight2 = new THREE.PointLight( 0x00ffff, .6);
    this.pointLight2.position.set( -500, -500, 20 );
    this.pointLight2.decay = 20;
    this.pointLight2.distance = 800;
    this.scene.add( this.pointLight2 );

    this.renderer = new THREE.WebGLRenderer({
      powerPreference: "low-power",
    });
    this.renderer.setSize( window.innerWidth, window.innerHeight );
    this.renderer.shadowMap.enabled = true;

    
    document.body.appendChild( this.renderer.domElement );
    // document.body.appendChild( this.effect.domElement );
    this.renderer.domElement.className = 'ascii-intro';
    // this.effect.domElement.className = 'ascii-intro';


    this.composer = new EffectComposer( this.renderer );
    this.composer.addPass( new RenderPass( this.scene, this.camera ) );

    this.asciiPass = new ShaderPass(this.shaderMaterial, "media");
    this.shaderMaterial.uniforms.media = this.composer.renderTarget1;
    this.composer.addPass( this.asciiPass );

    // this.controls = new TrackballControls( this.camera, this.effect.domElement );
    this.controls = new TrackballControls( this.camera, this.renderer.domElement );

    // Logo

    const material = new THREE.MeshPhongMaterial( { color: 0xAAAAAA, specular: 0x111111, shininess: 200 } );

    const loader = new STLLoader();
    loader.load( siteurl+'/assets/i/logo.stl', function(geometry) {

      // const material = new THREE.MeshBasicMaterial( { color: 0xff0000, specular: 0xff1111, shininess: 200 } );
      let material = new THREE.MeshPhongMaterial( { flatShading: true } );
      parent.logo = new THREE.Mesh( geometry, material );
      // const material = new THREE.MeshPhongMaterial( { color: 0xffffff, specular: 0xff0000, shininess: 100 } );
      // parent.logo = new THREE.Mesh( geometry, material );

      // mesh.position.set( 0, - 0.25, 0.6 );
      // mesh.rotation.set( 0, - Math.PI / 2, 0 );
      // mesh.scale.set( 0.5, 0.5, 0.5 );

      parent.logo.castShadow = true;
      parent.logo.receiveShadow = true;

      parent.logo.name = 'Logo';

      parent.logo.position.y = 0;
      parent.logo.position.z = 0.2;
      parent.logo.rotation.x = -0.4;

      parent.logo.rotation.z = Math.random() * Math.PI - (Math.PI/2);

      if(MOBSIZE) {
        parent.logo.rotation.z = THREE.Math.degToRad(45);
      }

      parent.logo.velocityArr = [0, 0, 0, 0, 0, 0, 0];
      parent.logo.mobLogoSpinArr = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      console.log('parent.logo done',parent.logo);

      parent.scene.add( parent.logo );

      parent.renderer.domElement.classList += ' show';

      parent.start = Date.now()

    });

    // Intersector
    const intersectorGeometry = new THREE.PlaneGeometry( 1000, 1000 );
    const intersectorMaterial = new THREE.MeshBasicMaterial( {
      color: 0xffff00,
      visible: false,
    });

    this.intersector = new THREE.Mesh( intersectorGeometry, intersectorMaterial );

    const spriteMap = new THREE.TextureLoader().load( siteurl+'/assets/i/fadeSpriteLess.png' );
    const spriteMaterial = new THREE.SpriteMaterial( {
      map: spriteMap,
      depthTest: false,
    } );

    this.sprite = new THREE.Sprite( spriteMaterial );
    this.sprite.scale.set(this.ORIGSPRITESCALE, this.ORIGSPRITESCALE, this.ORIGSPRITESCALE)
    this.sprite.position.x = 9999;
    this.sprite.position.y = 9999;
    this.sprite.position.z = 20;
    this.scene.add( this.sprite );

    this.raycaster = new THREE.Raycaster();
  }

  onWindowResize() {


    this.renderer.setSize( window.innerWidth, window.innerHeight );
    this.composer.setSize( window.innerWidth, window.innerHeight );
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.shaderMaterial.uniforms.resolution.value.x = window.innerWidth;
    this.shaderMaterial.uniforms.resolution.value.y = window.innerHeight;
    // this.effect.setSize( window.innerWidth, window.innerHeight );

  }

  animate() {
    window.introRaf = requestAnimationFrame( this.animate );

    if(this.shaderMaterial){
      this.shaderMaterial.uniforms.time.value = this.clock.getElapsedTime();
    }
    this.render();
  }

  render() {
    if(this.start) {
      const timer = Date.now() - this.start;

      if(this.logo) {
        const firstStateDur = 1900;
        const secondStateDur = 3000;
        const thirdStateDur = 2000;

        const progressFade = easeOutQuad( Math.min(firstStateDur, timer) / firstStateDur );
        const progressSpin = easeOutQuad( Math.min(secondStateDur, timer) / secondStateDur );

        this.pointLight1.intensity = progressFade*progressFade;

        if(progressSpin < 1.0) {
          // this.pointLight2.intensity = 0.1 * -progressSpin;
        }

        if(!MOBSIZE) {
          this.logo.rotation.z *= .96;
        }

        // console.log(progressSpin);
        // if(progressSpin < 1) {

          if(progressFade<1.0) {
            this.logo.position.z = (1-progressFade) * -800 + 10;

            let rotVal = (-(Math.PI*.5) * (1-progressSpin));
            this.logo.rotation.x = rotVal - 0.4;

            if(MOBSIZE) {
              this.logo.position.z -= 100;
              this.logo.rotation.x = THREE.Math.degToRad(220);
              this.logo.rotation.x += rotVal - 0.4;
            } else {
              // oversize
              // this.logo.position.z += 200;
            }
          } else {

            if(MOBSIZE) {

            }

            if(!this.introDone){
              this.introDone = true;

              // this.effect.domElement.classList.remove('show');
              $('.wrap.home').addClass('show');

              setTimeout(function(){
                $('.textbox .kash').kashify();
              }, 800);
            }
          }
        // }

        if(!MOBSIZE) {
          this.logo.rotation.x += this.mouseCoords.y * 0.008 * -window.animSpeed;
          this.logo.rotation.y += this.mouseCoords.x * 0.006 * window.animSpeed;
        } else {
          this.logo.rotation.y += this.mouseCoords.x * 0.006 * window.animSpeed;

          let mobLogoSpinArr = 0;
          for(var v=0;v<this.logo.mobLogoSpinArr.length;v++) {
            mobLogoSpinArr += this.logo.mobLogoSpinArr[v];
          }
          mobLogoSpinArr /= this.logo.mobLogoSpinArr.length;
          this.logo.rotation.z += (mobLogoSpinArr * 0.1) * (Math.max(0.1, window.animSpeed));

          if(!this.mousemoved) {
            this.logo.mobLogoSpinArr.unshift(mobLogoSpinArr*.8);
            this.logo.mobLogoSpinArr.pop();
          }
        }

        let velocityAvg = 0;

        if(!window.scrolling) {
          this.logo.velocityArr.unshift(0);
          this.logo.velocityArr.pop();
        }

        for(var v=0;v<this.logo.velocityArr.length;v++) {
          velocityAvg += this.logo.velocityArr[v];
        }
        velocityAvg /= this.logo.velocityArr.length;
        this.logo.position.z += velocityAvg;

        if(this.logo.position.z > 500) this.logo.position.z = -1300;
        if(this.logo.position.z < -1300) this.logo.position.z = 500;


        if(this.sprite){
          var spriteScale = this.ORIGSPRITESCALE + (Math.sin(timer*0.001) * 5);
          this.sprite.scale.set(spriteScale, spriteScale, spriteScale)
        }

        this.controls.update();
        this.composer.render(this.scene, this.camera);
        // this.effect.render( this.scene, this.camera );

        window.scrolling = false;
      }
    }
  }

  onDocumentMouseMove( event ) {
    this.mousemove( event.clientX, event.clientY, 0 );
  }
  onDocumentTouchMove( event ) {
    if ( event.touches.length === 1 ) {
      // event.preventDefault();
      this.mousemove( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY, 0 );
    }
  }

  mousemove( x, y ) {
    // console.log(this.mouseCoords);
    var prevCoords = this.mouseCoords.clone();

    this.mouseCoords.set( ( x / window.innerWidth ) * 2 - 1, - ( y / window.innerHeight ) * 2 + 1, 0 );
    if(MOBSIZE) {
      // var dist = prevCoords.manhattanDistanceTo(this.mouseCoords);
      var dist = prevCoords.sub(this.mouseCoords);
      if(!this.mousemoved) dist = new THREE.Vector3(0, 0, 0);
      if(y < window.innerHeight/2) dist.x = -dist.x;
      if(x < window.innerWidth/2) dist.y = -dist.y;
      var speed = (dist.x + dist.y) * 1;
      // console.log(speed);
      this.logo.mobLogoSpinArr.unshift(speed * 7);
      this.logo.mobLogoSpinArr.pop();
      // console.log(prevCoords, this.mouseCoords);
    }

    this.raycaster.setFromCamera( this.mouseCoords, this.camera );
    var intersects = this.raycaster.intersectObject( this.intersector );
    if ( intersects.length > 0 ) {
      var point = intersects[ 0 ].point;
      this.sprite.position.set(point.x, point.y, 20);
      this.pointLight2.position.set(point.x, point.y, this.pointLight2.position.z);
    }
    this.colorVal += 0.000001;
    this.pointLight2.color = this.pointLight2.color.offsetHSL(Math.sin(this.colorVal), 1.0, 0.0)
    // this.material.uniforms.specular.value = this.pointLight2.color;
    // console.log(this.material.specular);

    var self = this;
    clearTimeout(window.mousemoveclear);
    this.mousemoved = true;
    window.mousemoveclear = setTimeout(function(){
      self.mousemoved = false;
    }, 20);
  }
}
